module.exports = __webpack_public_path__ + "img/sale_code_img.3e05cb51.png";